import './style/index.less'
import InputAmount from './InputAmount'

export default InputAmount